export default __webpack_public_path__ + "static/liwinski-cf149bf447bd31e7574940f6e1cc0b6a.jpg";